import { axiosApi } from '../../assets/axiosAPI';
import React from 'react';
import {Button, FormGroup, Form, Input, Label} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { API_PATH } from '../../assets/const';
import logo0 from '../../assets/images/logo_0.png';
import { createErrorMessage, removeErrorMessageElement, getSessionInfoGeneral } from '../../assets/common';

const RESOURCE_LOGIN = API_PATH + "/resources/login";

export default class Login extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            loginId:"",
            password:"",
            loginSuccess:false
        }
    }

    componentDidMount = () => {
        document.body.id = "login";
    }

    // ログインID欄のonChangeイベント
    changeLoginId = (event) => {
        this.setState({
            loginId:event.target.value
        })
    }

    //パスワード欄のonChangeイベント
    changePassword = (event) => {
        this.setState({
            password:event.target.value
        })
    }

    //ログインボタン押下時のイベント
    loginClick = () => {
        //画面に表示されているエラーメッセージ要素を削除
        removeErrorMessageElement();        
        axiosApi
            .post(RESOURCE_LOGIN, {
                loginId:this.state.loginId,
                password:this.state.password
            })
            .then(() => {
                this.setState({
                    loginSuccess:true
                })
            })
            .catch((error) => {
                if(error.response){
                    //通信時のエラー
                    const _statusCode = error.response.status;
                    if(_statusCode === 400){
                        //BadRequest
                        //画面に表示するエラーメッセージを作成
                        let errorData = error.response.data.errorInfo;
                        if(errorData){
                            if(!Array.isArray(errorData)){
                                if(errorData.error ==="LockOut"){
                                    alert('このアカウントは、一時的に利用できません。\n'+errorData.param+'までお待ちください。');
                                }
                            }else{
                                alert('IDまたはパスワードが異なります。');
                            }
                        }else{
                            alert('IDまたはパスワードが異なります。');
                        }
                    }else if(_statusCode === 404){
                        alert('IDまたはパスワードが異なります。');
                        this.setState({
                            loginSuccess:false
                        })
                    }else{
                        alert('サーバーとの接続に失敗しました。');
                        this.setState({
                            loginSuccess:false
                        })
                    }
                }else{
                    //レスポンス取得後のエラー, 通信できないときのエラー
                    alert('エラーが発生しました。');
                    this.setState({
                        loginSuccess:false
                    })                   
                }
            })
    }
    
    render(){
        if (this.state.loginSuccess){
            //ログインAPIで認証成功時のJSX
            return (
                <Redirect to={'/Home'} />
            )
        }
        else{
            //ログインAPIで認証失敗時、初期表示時のJSX
            return(
                <div className="loginform-wrapper">
		            <h1>
                        <br/><img src={logo0} width="170" alt=""/><br/>
			            WAN運用支援サービス<br/>
			            -レポートサービス-
                    </h1>                    
                    <Form>
                        <FormGroup className="loginId loginform-formgroup">
                            <Label>ログインID</Label>
                            <Input 
                            className = "loginform-textBox"
                            maxLength="200"
                            onChange={this.changeLoginId} />
                        </FormGroup>
                        <FormGroup className="password loginform-formgroup">
                            <Label>パスワード</Label>
                            <Input 
                            className = "loginform-textBox"
                            type="password"
                            maxLength="200"
                            onChange={this.changePassword}
                             />
                        </FormGroup>
                    </Form>
                    <div className={"button-panel" + " " + "loginform"} style={{ textAlign:"center"}}>
                        <Button 
                        color="primary" 
                        onClick={this.loginClick}>ログイン</Button>
                    </div>
                </div>
            )
        }
    }
}